import React from 'react';
import { FunnelIcon } from '@heroicons/react/24/outline';
import ScrollableDropdown from '../ScrollableDropdown';

const ApplicationFilters = ({ filters, onChange, onClear, developers = [], versions = [] }) => {
    return (
        <div className="bg-white p-4 border-b border-gray-200 shadow-sm animate-fade-in-down">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2">
                    <FunnelIcon className="h-4 w-4 text-gray-500" />
                    Advanced Filters
                </h3>
                <button
                    onClick={onClear}
                    className="text-xs text-red-600 hover:text-red-800 font-medium"
                >
                    Clear all
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Status Filter */}
                <div className="lg:hidden">
                    <label className="block text-xs font-medium text-gray-700 mb-1">Status</label>
                    <ScrollableDropdown
                        value={filters.status}
                        onChange={(value) => onChange('status', value)}
                        options={[
                            { value: 'all', label: 'All Statuses' },
                            { value: 'Active', label: 'Active' },
                            { value: 'Inactive', label: 'Inactive' },
                        ]}
                        placeholder="All Statuses"
                        buttonHeightClassName="h-9"
                        maxMenuHeightPx={240}
                        maxMenuHeightClassName="max-h-60"
                    />
                </div>

                {/* Developer Filter */}
                <div className="lg:hidden">
                    <label className="block text-xs font-medium text-gray-700 mb-1">Developer</label>
                    {/* If we had a list of devs, we'd map them. For now simple input or derived list? 
               I'll presume passed developers list or just text for now to be safe.*/}
                    <ScrollableDropdown
                        value={filters.developerId}
                        onChange={(value) => onChange('developerId', value)}
                        options={[
                            { value: 'all', label: 'All Developers' },
                            ...developers.map((dev) => ({ value: dev._id || dev.name, label: dev.name }))
                        ]}
                        placeholder="All Developers"
                        buttonHeightClassName="h-9"
                        maxMenuHeightPx={240}
                        maxMenuHeightClassName="max-h-60"
                    />
                </div>

                {/* Version Filter - Maybe too specific? Just show 'Latest' option or input? prompt says 'Version'. */}
                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">Version</label>
                    <input
                        type="text"
                        placeholder="e.g. 1.0"
                        value={filters.version}
                        onChange={(e) => onChange('version', e.target.value)}
                        className="block w-full rounded-md border-gray-300 py-1.5 text-sm focus:border-indigo-500 focus:ring-indigo-500"
                    />
                </div>

            </div>
        </div>
    );
};

export default ApplicationFilters;
